import { gql } from "@apollo/client";

export default gql`
  mutation sendProgramReminderMutation(
    $complianceProgramId: Int!
    $message: String
    $overdueOnly: Boolean
    $nominationsUserIds: [Int]
    $oneononeStatusUserIds: [Int]
    $performanceAssessmentStatusUserIds: [Int]
    $performanceSelfAssessmentStatusUserIds: [Int]
    $managerAssessmentStatusUserIds: [Int]
    $peerAssessmentStatusUserIds: [Int]
    $engagementSurveyStatusUserIds: [Int]
    $emailNotification: Boolean!
    $slackNotification: Boolean!
    $teamsNotification: Boolean
  ) {
    sendProgramReminder(
      complianceProgramId: $complianceProgramId
      message: $message
      overdueOnly: $overdueOnly
      nominationsUserIds: $nominationsUserIds
      oneononeStatusUserIds: $oneononeStatusUserIds
      performanceAssessmentStatusUserIds: $performanceAssessmentStatusUserIds
      performanceSelfAssessmentStatusUserIds: $performanceSelfAssessmentStatusUserIds
      managerAssessmentStatusUserIds: $managerAssessmentStatusUserIds
      peerAssessmentStatusUserIds: $peerAssessmentStatusUserIds
      engagementSurveyStatusUserIds: $engagementSurveyStatusUserIds
      emailNotification: $emailNotification
      slackNotification: $slackNotification
      teamsNotification: $teamsNotification
    ) {
      didSend
      complianceProgram {
        id
      }
    }
  }
`;
